import React from "react";
import styled from "@emotion/styled";
import { AppBar, Box, Toolbar } from "@mui/material";
import { Link, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import isPropValid from "@emotion/is-prop-valid";
import ContractsActive from "@icons/quickbar/Contracts_active.svg?react";
import HomeActive from "@icons/quickbar/Home_active.svg?react";
import InvestmentsActive from "@icons/quickbar/Investments_active.svg?react";
import Analyzer from "@icons/quickbar/Analyser.svg?react";
import Contracts from "@icons/quickbar/Contracts.svg?react";
import Home from "@icons/quickbar/Home.svg?react";
import Investments from "@icons/quickbar/Investments.svg?react";
import AnalyzerActive from "@icons/quickbar/Analyser_active.svg?react";

const QuickNav = styled(AppBar)`
  display: flex;
  top: auto;
  bottom: 0;
  height: 54px;
  box-shadow: none;
  border: 1px solid ${({ theme }) => theme.palette.border.secondary};
  background: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.background.sidebar
      : theme.palette.background.default};
  z-index: 3000;
`;

const QuickNavToolbar = styled(Toolbar)`
  display: flex;
  padding-left: 0;
  padding-right: 0;
  min-height: 54px !important;
`;

const QuickNavItem = styled(Link, {
  shouldForwardProp: (prop: string) => isPropValid(prop) || prop !== "active",
})<{
  active: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  border-bottom-color: ${({ theme, active }) =>
    active ? theme.palette.primary.dark : theme.palette.background.default};
  border-bottom-style: solid;
  border-bottom-width: 3px;
  color: ${({ theme, active }) =>
    active ? theme.palette.primary.dark : theme.palette.text.secondary};
`;

const quickbarItems = [
  {
    to: "/",
    text: "quickBar.home",
    icon: <Home />,
    activeIcon: <HomeActive />,
  },
  {
    to: "/investments",
    text: "quickBar.investments",
    icon: <Investments />,
    activeIcon: <InvestmentsActive />,
  },
  {
    to: "/depots-accounts",
    text: "quickBar.depots",
    icon: <Contracts />,
    activeIcon: <ContractsActive />,
  },
  {
    to: "/classifications",
    text: "quickBar.analyse",
    icon: <Analyzer />,
    activeIcon: <AnalyzerActive />,
  },
];

export const Quickbar = ({
  ref,
  ...props
}: { ref?: React.Ref<HTMLDivElement> } & Record<string, any>) => {
  const location = useLocation();
  const { t } = useTranslation();
  const isActive = (path?: string) => location.pathname === path;

  return (
    <QuickNav ref={ref} position="fixed" id="app-bar">
      <QuickNavToolbar>
        {quickbarItems.map((qi, idx) => (
          <QuickNavItem key={idx} to={qi.to || ""} active={isActive(qi.to)}>
            <Box
              color={isActive(qi.to) ? "icon.active" : "icon.secondary"}
              display="flex"
              alignItems="center"
            >
              {isActive(qi.to) ? qi.activeIcon : qi.icon}
            </Box>
            {t(qi.text)}
          </QuickNavItem>
        ))}
      </QuickNavToolbar>
    </QuickNav>
  );
};
